import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=55321509"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports